// :NOTE this file is the same as createChordDiagramPrivate
// This is because the api endpoint is now built to know your role on RT and if the rt is anonymous
// it is now a general endpoint that can be used by all people in rt
// depending on which api version the naming of this service makes more sense as createChordDiagram
import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('get', `/api/roundtables/${id}/chord-diagram`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/dataVisualization/createChordDiagram.js